export const leadTypeOptions = ['New Deal', 'Add-on', 'Refinance', 'Reverse', 'Buy Out'] as const
